import React from 'react';

export const VeteranBadge = ({ size = 60, idPrefix = "badge", className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    style={{filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'}}
  >
    <defs>
      {/* Silver Ring Gradient */}
      <linearGradient id={`${idPrefix}-silverRing`} x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="30%" stopColor="#E5E5E5" />
        <stop offset="50%" stopColor="#A8A8A8" />
        <stop offset="70%" stopColor="#E5E5E5" />
        <stop offset="100%" stopColor="#FFFFFF" />
      </linearGradient>
      
      {/* Bronze Badge Center Gradient */}
      <linearGradient id={`${idPrefix}-bronzeBadge`} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#A67C52" />
        <stop offset="50%" stopColor="#8B5E3C" />
        <stop offset="100%" stopColor="#5C4033" />
      </linearGradient>
      
      {/* Clip Path for Flag Stripes */}
      <clipPath id={`${idPrefix}-innerCircle`}>
        <circle cx="50" cy="50" r="38" />
      </clipPath>
    </defs>
    
    {/* Outer Silver Ring */}
    <circle cx="50" cy="50" r="48" fill={`url(#${idPrefix}-silverRing)`} stroke="#9CA3AF" strokeWidth="1" />
    <circle cx="50" cy="50" r="42" fill="none" stroke="#B0B0B0" strokeWidth="2" />
    
    {/* Bronze Center */}
    <circle cx="50" cy="50" r="38" fill={`url(#${idPrefix}-bronzeBadge)`} />
    
    {/* American Flag Pattern (subtle) */}
    <g clipPath={`url(#${idPrefix}-innerCircle)`} opacity="0.4">
      <rect x="12" y="26" width="76" height="5" fill="#EF4444" />
      <rect x="12" y="36" width="76" height="5" fill="#EF4444" />
      <rect x="12" y="46" width="76" height="5" fill="#EF4444" />
      <rect x="12" y="56" width="76" height="5" fill="#EF4444" />
      <rect x="12" y="66" width="76" height="5" fill="#EF4444" />
      <rect x="12" y="26" width="32" height="25" fill="#8B5E3C" />
    </g>
    
    {/* Inner Ring Highlight */}
    <circle cx="50" cy="50" r="34" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
    
    {/* Top Stars */}
    <g fill="white" fontSize="6" fontFamily="Arial">
      <text x="30" y="33" textAnchor="middle">★</text>
      <text x="38" y="32" textAnchor="middle">★</text>
      <text x="46" y="31" textAnchor="middle">★</text>
      <text x="54" y="31" textAnchor="middle">★</text>
      <text x="62" y="32" textAnchor="middle">★</text>
      <text x="70" y="33" textAnchor="middle">★</text>
    </g>
    
    {/* VETERAN OWNED Text - Pure white with shadow for visibility */}
    <text x="50" y="50" textAnchor="middle" fill="#FFFFFF" fontSize="11" fontWeight="900" fontFamily="Arial Black, Arial" letterSpacing="1" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>VETERAN</text>
    <text x="50" y="63" textAnchor="middle" fill="#FFFFFF" fontSize="11" fontWeight="900" fontFamily="Arial Black, Arial" letterSpacing="1" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>OWNED</text>
    
    {/* Bottom Stars */}
    <g fill="white" fontSize="6" fontFamily="Arial">
      <text x="30" y="75" textAnchor="middle">★</text>
      <text x="38" y="76" textAnchor="middle">★</text>
      <text x="46" y="77" textAnchor="middle">★</text>
      <text x="54" y="77" textAnchor="middle">★</text>
      <text x="62" y="76" textAnchor="middle">★</text>
      <text x="70" y="75" textAnchor="middle">★</text>
    </g>
  </svg>
);
